import React from "react";
import { Chip, MenuItem, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { app } from "../../services";

const normalizeIds = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value.map((v) => String(v));
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed.map((v) => String(v));
      if (Array.isArray(parsed?.processes)) return parsed.processes.map((v) => String(v));
      return [];
    } catch (e) {
      return [];
    }
  }
  if (Array.isArray(value?.processes)) return value.processes.map((v) => String(v));
  return [];
};

export default function ProcessExclusionsInput({
  id,
  field,
  label,
  variant = "standard",
  defaultValue
}) {
  const institution = useSelector((state) => state.session.institution);
  const [options, setOptions] = React.useState([]);
  const [selected, setSelected] = React.useState(normalizeIds(defaultValue));

  React.useEffect(() => {
    setSelected(normalizeIds(defaultValue));
  }, [defaultValue]);

  React.useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const res = await app.service("processes").find({
          query: {
            id_institucion: institution?.id,
            $limit: 500,
            $skip: 0,
            $sort: { nu_orden: 1, vc_nombre: 1 }
          }
        });
        if (!mounted) return;
        const rows = Array.isArray(res?.data) ? res.data : [];
        setOptions(rows);
      } catch (e) {
        if (!mounted) return;
        setOptions([]);
      }
    };
    if (institution?.id) load();
    return () => {
      mounted = false;
    };
  }, [institution?.id]);

  const serialized = JSON.stringify({ processes: selected });

  return (
    <>
      <TextField
        select
        SelectProps={{
          multiple: true,
          value: selected,
          onChange: (event) => {
            const val = event.target.value;
            setSelected(Array.isArray(val) ? val.map((v) => String(v)) : []);
          },
          renderValue: (selectedIds) => (
            <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
              {(selectedIds || []).map((pid) => {
                const item = options.find((o) => String(o.id) === String(pid));
                return <Chip key={pid} size="small" label={item?.vc_nombre || pid} />;
              })}
            </div>
          )
        }}
        variant={variant}
        fullWidth
        label={label}
        placeholder={field?.placeholder}
        disabled={!!field?.readOnly}
        InputLabelProps={{
          sx: {
            color: "gray",
            padding: "5px 10px"
          }
        }}
        InputProps={{
          disableUnderline: true,
          style: {
            padding: "4px 10px",
            backgroundColor: "rgba(200,200,200,0.1)",
            boxShadow: "0px 0px 2px gray",
            borderRadius: 10
          }
        }}
      >
        {options.map((process) => (
          <MenuItem key={process.id} value={String(process.id)}>
            {process.vc_nombre}
          </MenuItem>
        ))}
      </TextField>

      <input id={id} value={serialized} readOnly hidden />
    </>
  );
}
